// extracted by mini-css-extract-plugin
export default {"root":"_1B9SJF5dN4Z2gqN5te2TZf"};